module.exports = __webpack_public_path__ + "static/img/us.9fefb4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us.jpg
// module id = 1cRf
// module chunks = 1